import { tags as initialState } from 'flux/initialState'
import { tags as actions } from 'flux/actions'

export default function (state = initialState, action) {
  const { types } = actions

  switch (action.type) {
    case types.SEARCH: {
      const { query } = action.payload
      return { ...state, query }
    }
    case types.ADD_VISIBLE_TAG_ID:
      return {
        ...state,
        visibleTagsId: [...state.visibleTagsId, action.payload.tagId],
      }
    case types.REMOVE_VISIBLE_TAG_ID:
      return {
        ...state,
        visibleTagsId: state.visibleTagsId.filter((tagId) => action.payload.tagId !== tagId),
      }
    case types.SET_SELECTED_VARIANT_INDEX: {
      const { activeParentTagId, selectedVariantIndex } = action.payload

      return {
        ...state,
        activeParentTagId,
        selectedVariantIndex,
      }
    }
    default:
      return state
  }
}
